import { useEffect } from 'react';
import { AlertIcon } from './icons';
import './Modal.css';

function Modal({ title, message, onClose }) {
  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className="modal-overlay" role="presentation">
      <div className="modal-dialog" role="alertdialog" aria-modal="true" aria-labelledby="modal-title">
        <AlertIcon className="modal-dialog__icon" />
        <h3 id="modal-title">{title}</h3>
        <p>{message}</p>
        <button type="button" className="modal-dialog__btn" onClick={onClose} autoFocus>
          Đã hiểu
        </button>
      </div>
    </div>
  );
}

export default Modal;
